import MasterTable from './MasterTable'

/* ข้อมูลหลัก → แผนก · backend: src/routes/adminDepartments.js

   ⚠️ คีย์คือ DepartCode ไม่ใช่ DepartNo — DepartNo **มีค่าซ้ำกัน** ในของจริง
      จึงเป็นแค่เลขไว้แสดง/เรียง ไม่ใช่ตัวระบุแถว
   ⚠️ ในฐานข้อมูลเก็บเป็น DepartStatus (1 = ใช้งาน) แต่ API แปลงเป็น inactive
      ให้เหมือนตารางอื่นแล้ว หน้านี้จึงไม่ต้องรู้เรื่องการกลับขั้ว */

type Department = {
  DepartCode: string
  DepartName: string
  DepartNo: number
  CompanyCode: string
  CompanyName: string | null
  inactive: boolean
  staffCount: number
}

export default function Departments() {
  return (
    <MasterTable<Department>
      title="แผนก"
      unit="แผนก"
      companyScoped
      addLabel="เพิ่มแผนก"
      base="/api/admin/departments"
      keyOf={(r) => r.DepartCode}
      labelOf={(r) => `${r.DepartCode} ${r.DepartName}`}
      isInactive={(r) => r.inactive}
      cols={[
        { label: 'บริษัท', cell: (r) => r.CompanyCode, sortKey: 'company' },
        { label: 'รหัส', cell: (r) => r.DepartCode, sortKey: 'code' },
        { label: 'ชื่อแผนก', cell: (r) => r.DepartName, sortKey: 'name' },
        { label: 'พนักงาน', cell: (r) => r.staffCount, num: true, sortKey: 'staff' },
      ]}
      fields={[
        /* ย้ายแผนกข้ามบริษัทไม่ได้หลังสร้าง — Users ผูกด้วย (DepartCode, CompanyCode)
           คู่กัน ถ้าเปลี่ยนบริษัทของแผนก พนักงานเดิมจะหลุดจากแผนกทันที */
        { name: 'companyCode', label: 'บริษัท', required: true, lockOnEdit: true, source: 'companies' },
        { name: 'departCode', label: 'รหัสแผนก', maxLength: 20, required: true, lockOnEdit: true },
        { name: 'departName', label: 'ชื่อแผนก', maxLength: 100, required: true },
      ]}
      toDraft={(r) => ({
        companyCode: r.CompanyCode,
        departCode: r.DepartCode,
        departName: r.DepartName,
      })}
    />
  )
}
